import { api } from "../api";
import { withoutActorIdentity } from "./actorIdentity";

export const registerAffiliate = async (request: any): Promise<any> => {
  const { data } = await api.post<object>(`/Affiliate/register`, withoutActorIdentity(request));
  return data;
};

export const renewAffiliate = async (request: any): Promise<any> => {
  const { data } = await api.post<object>(`/Affiliate/renew`, withoutActorIdentity(request));
  return data;
};

export const getMatchingAffiliateNames = async (
  affiliateName: string
): Promise<any> => {
  const { data } = await api.get<string[]>(
    `/Affiliate/search/${affiliateName}`
  );
  return data;
};

export const getAffiliateMemberTypes = async (): Promise<object> => {
  const { data } = await api.get<object>(`/Affiliate/member/types`);
  return data;
};

export default {
  registerAffiliate,
  renewAffiliate,
  getMatchingAffiliateNames,
  getAffiliateMemberTypes,
};
